import { render } from "./Breadcrumb.vue?vue&type=template&id=bc78946a"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=bc78946a&lang=css"
script.render = render

export default script